import React from 'react';
//Components
import {Grid,Avatar} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
//Styles
//import { MainColors } from '../mainpages/Sources/SourcesConst';
import { makeStyles } from '@material-ui/core/styles';
import {color_accent_, color_secondary_} from '../Constants';

const useStyles = makeStyles(() => ({
    msg:{
        fontSize: '3vh',
        //fontSize: '13pt',
        fontWeight: '300',
        //color: MainColors.secondary,
        color: '#CB4335',
        padding: '0',
        margin: '2vh 0 0 0',
    },
    back: {
        width: '100%',
        height: '100%',
        padding: 'auto',
        //color: MainColors.accent,
        backgroundColor: '#fff',
    },
    img:{
        //margin: 'auto',
        margin: '2vh 0 0 0',
        width: '6vh',
        height: '6vh',
    },
}));

export default function SubTitleBack(props){

    const sty = useStyles();

    return(
        <Grid  container direction="row" justify="center" alignItems="center">
            <Grid item xs={2}>
                <Avatar onClick={() => props.back()} className={sty.back} style={{color: localStorage.getItem(color_accent_)}} alt="Add icon">
                    <ArrowBackIcon className={sty.img}/>
                </Avatar>
            </Grid>
            <Grid item xs={9}>
                <p className={sty.msg} style={{color: localStorage.getItem(color_secondary_)}}>{props.msg}</p>
            </Grid>
        </Grid>
    )
}